import { render, staticRenderFns, recyclableRender, components } from "./u-swipe-action.vue?vue&type=template&id=7a79cf07&scoped=true&"
var renderjs
import script from "./u-swipe-action.vue?vue&type=script&lang=js&"
export * from "./u-swipe-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a79cf07",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-swipe-action/u-swipe-action.vue"
export default component.exports